import React from 'react';
import { GridColumn as Component } from '@vfuk/core-grid';
const GridColumn = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default GridColumn;
